document.addEventListener('DOMContentLoaded', function () {
  function updateMainPriceFromQikify() {
    const mainPriceEl = document.querySelector('.price-item.price-item--regular');
    const selectedTierPriceEl = document.querySelector(
      '.qvl-volume-tier--selected .qvl-volume-tier__price--offer-per-unit'
    );

    if (!mainPriceEl || !selectedTierPriceEl) return;

    mainPriceEl.textContent = selectedTierPriceEl.textContent.trim();
  }

  function bindQikifyPriceSync() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('.qvl-volume-tier__radio__input')) {
        setTimeout(updateMainPriceFromQikify, 80);
      }
    });

    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.qvl-volume-tier') ||
        e.target.closest('.qvl-volume-tier__radio__label')
      ) {
        setTimeout(updateMainPriceFromQikify, 80);
      }
    });
  }

  function observeQikifyChanges() {
    const qikifyRoot = document.querySelector('#qvl-embed-placeholder') || document.body;

    const observer = new MutationObserver(function () {
      updateMainPriceFromQikify();
    });

    observer.observe(qikifyRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked']
    });
  }

  bindQikifyPriceSync();
  observeQikifyChanges();

  setTimeout(updateMainPriceFromQikify, 200);
  setTimeout(updateMainPriceFromQikify, 500);
  setTimeout(updateMainPriceFromQikify, 1000);
});